import { i18n } from '@/plugins/i18n'

export const terminalSettlementType = {
    payment_helper: 1,
    psp: 2,
};

export const terminalSettlementTypeStr = {
    payment_helper: i18n.t('terminal_settlement_type.payment_helper'),
    psp: i18n.t('terminal_settlement_type.psp'),

    get(type) {
        let type_str = null;

        Object.keys(terminalSettlementType).forEach(item => {
            if(terminalSettlementType[item] === type) {
                type_str = terminalSettlementTypeStr[item];
            }
        });

        return type_str;
    }
};

export const terminalSettlementTypes=[
    {
        name: terminalSettlementTypeStr.payment_helper,
        value: terminalSettlementType.payment_helper
    },
    {
        name: terminalSettlementTypeStr.psp,
        value: terminalSettlementType.psp
    },
];